import { Link } from "react-router-dom";
import { FileText, Trash2 } from "lucide-react";
import { inr, monthLabel } from "../../lib/format";

export const PayslipList = ({ slips, onDelete }) => {
  const list = Array.isArray(slips) ? slips : [];
  if (!list.length) return <p className="border border-dashed border-white/15 p-8 text-center text-[var(--bone-2)]" data-testid="payslips-empty">No salary slips yet.</p>;
  return (
    <ul className="divide-y divide-white/10 border-y border-white/10" data-testid="payslip-list">
      {list.map((s) => (
        <li key={s.id} className="flex flex-wrap items-center justify-between gap-4 py-4" data-testid={`payslip-row-${s.month}`}>
          <div>
            <p className="font-display text-2xl font-extrabold uppercase">{monthLabel(s.month)}</p>
            <p className="text-sm text-[var(--bone-2)]">Paid days {s.paid_days} / {s.working_days} · Net <span className="text-[var(--signal)]">{inr(s.net)}</span></p>
          </div>
          <div className="flex items-center gap-2">
            <Link to={`/payslips/${s.id}`} data-testid={`payslip-view-${s.month}`}
              className="flex items-center gap-2 rounded-full border border-white/25 px-4 py-2 text-sm transition-colors hover:border-[var(--signal)] hover:text-[var(--signal)]">
              <FileText className="h-4 w-4" /> View / Download
            </Link>
            {onDelete && (
              <button onClick={() => onDelete(s)} className="rounded-full border border-red-400/50 p-2 text-red-300" data-testid={`payslip-delete-${s.month}`} title="Delete">
                <Trash2 className="h-4 w-4" />
              </button>
            )}
          </div>
        </li>
      ))}
    </ul>
  );
};
